
namespace TabAurous.SalesOrder{

    @Serenity.Decorators.registerClass()
    export class SalesOrderGrid extends _Ext.GridBase<SalesOrderRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrder'; }
        protected getDialogType() { return SalesOrderDialog; }
        protected getIdProperty() { return SalesOrderRow.idProperty; }
        protected getInsertPermission() { return SalesOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesOrderRow.localTextPrefix; }
        protected getService() { return SalesOrderService.baseUrl; }
        public rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();
            var dt = now.getDay();
            var mt = now.getMonth();
            var yr = now.getUTCFullYear();
            var hr = now.getUTCHours();
            var mn = now.getUTCMinutes();
            var sc = now.getUTCSeconds();

            var voucherNo = FormatHelper.GetVoucherNo(16);

            this.editItem(<SalesOrderRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                VoucherTypeId: 16,
                TransDate: now.toDateString(),
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        protected getButtons(): Serenity.ToolButton[] {
            var btn = super.getButtons();
            btn.push({
                title: 'Export',
                cssClass: 'send-button',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    let _orderDetailsRows: SalesOrderItemsRow[] = [];
                    this.view.getItems().forEach((v, i) => {
                        _orderDetailsRows.push({});
                    });
                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: SalesOrderService.baseUrl + '/OrderDetailExportExcel',
                        request: {
                            orderDetailsRows: _orderDetailsRows,
                        },

                        target: '_blank'
                    });
                }
            });
            btn.push( {
                title: 'Export only Selected Orders',
                cssClass: 'send-button',
                onClick: () => {
                    if (!this.onViewSubmit()) {
                        return;
                    }
                    //  let _orderDetailsRows: OMSOrderItemRow[] = [];
                    var action = this.rowSelection.getSelectedKeys();
                    var x = action.length;

                    //action.done = () => this.rowSelection.resetCheckedAndRefresh();
                    // action.execute(this.rowSelection.getSelectedKeys());
                    Q.postToService({
                        service: SalesOrderService.baseUrl + '/OrderDetailSelectedExportExcel',
                        request: {
                            x: action,
                        },

                        target: '_blank'
                    });
                }
            });

            //btn.push( {
            //    title: 'Import ECommerce Orders',
            //    cssClass: 'import-xlsx-button',
            //    onClick: () => {
            //        if (!this.onViewSubmit()) {
            //            return;
            //        }
            //        var grid = Common.ECommOrderSelectGrid;

            //        var pickerDialog = new _Ext.GridItemPickerDialog({
            //            gridType: grid, multiple: true 
            //        });

            //        pickerDialog.dialogOpen();
            //    }
            //});
            return btn;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
    }
}